import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import {APP_CONFIG, AppConfig} from './config';
import { Favorite } from '../Models/favorite';

/**
 * HTTP client of the backend `/new/favorites` endpoints, which return raw bodies (no `Response` wrapper).
 * The session is a cookie: every call sends it (`withCredentials`), like the other services.
 */
@Injectable({
    providedIn: 'root',
})
export class FavoriteService {

    url: string;

    constructor(private http: HttpClient, @Inject(APP_CONFIG) private appConfig: AppConfig) {
        // AbstractFavoriteControllerV1, mapped on `/new/favorites` (the old `/favorites` one is deprecated)
        this.url = `${this.appConfig.apiEndpoint}/new/favorites`;
    }

    /** Creates a favorite and returns its id */
    public add(favorite: { clientId: number; productConfigurationId: number }): Observable<number> {
        return this.http.post<number>(this.url, favorite, { withCredentials: true });
    }

    /** Creates several favorites at once (no duplicate check on the backend: filter before calling) */
    public saveAll(favorites: { clientId: number; productConfigurationId: number }[]): Observable<number[]> {
        return this.http.post<number[]>(`${this.url}/save-all`, favorites, { withCredentials: true });
    }

    public delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${id}`, { withCredentials: true });
    }

    public getByClientId(id: number): Observable<Favorite[]> {
        return this.http.get<Favorite[]>(`${this.url}/client/${id}`, { withCredentials: true });
    }

    /** Favorites of the logged-in client, with their product configuration */
    public getCurrentClient(): Observable<Favorite[]> {
        return this.http.get<Favorite[]>(`${this.url}/current-client`, { withCredentials: true });
    }

}
